__turbopack_context__.v({
  "columnsWrapper": "dropdown-module-scss-module__GVb2NW__columnsWrapper",
  "dropdown": "dropdown-module-scss-module__GVb2NW__dropdown",
  "dropdownContainer": "dropdown-module-scss-module__GVb2NW__dropdownContainer",
  "dropdownContainerSlim": "dropdown-module-scss-module__GVb2NW__dropdownContainerSlim",
  "dropdownHidden": "dropdown-module-scss-module__GVb2NW__dropdownHidden",
  "highlighted": "dropdown-module-scss-module__GVb2NW__highlighted",
  "item": "dropdown-module-scss-module__GVb2NW__item",
  "itemList": "dropdown-module-scss-module__GVb2NW__itemList",
  "section": "dropdown-module-scss-module__GVb2NW__section",
  "sectionTitle": "dropdown-module-scss-module__GVb2NW__sectionTitle",
  "slide-down": "dropdown-module-scss-module__GVb2NW__slide-down",
});
